export default __webpack_public_path__ + "static/media/athlete2.b216a5ad.png";